import { render, staticRenderFns } from "./PrintPosFacturaTicket.vue?vue&type=template&id=e0469734&scoped=true"
import script from "./PrintPosFacturaTicket.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaTicket.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaTicket.vue?vue&type=style&index=0&id=e0469734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0469734",
  null
  
)

export default component.exports